module.exports = __webpack_public_path__ + "static/media/room1_1.01d755a3.JPG";